// Project the selected conversation's durable steering records into this tab.
// Resolve read/sent ids first so older unread reports cannot bring them back.
import { queuedSteerIds } from './origin';
import { steerReadPart, steerUnreadPart, type SteerMessage } from './parts';
import { steerStore } from './store';

export function reconcileSteerHistory(
  threadId: string,
  messages: readonly SteerMessage[],
  isRunning: boolean,
  store = steerStore,
) {
  const resolved = messages.flatMap((message) =>
    message.role === 'assistant'
      ? message.content.flatMap((part) => {
          const read = steerReadPart(part);
          return read ? [read.id] : [];
        })
      : queuedSteerIds(message),
  );
  store.consume(threadId, resolved);
  for (const message of messages) {
    if (message.role !== 'assistant' || (isRunning && message === messages.at(-1))) continue;
    for (const part of message.content) {
      const unread = steerUnreadPart(part);
      if (unread) store.unread(threadId, unread.reason, unread.messages);
    }
  }
}
